import metadata from './block.json';
import { ValidatedTextInput } from '@woocommerce/blocks-checkout';
import { __ } from '@wordpress/i18n';
import { useEffect, useState, useCallback } from '@wordpress/element';

// Global import
const { registerCheckoutBlock } = window.wc.blocksCheckout;

const Block = ({ checkoutExtensionData }) => {
	const [roomNumber, setRoomNumber] = useState('');
	const { setExtensionData } = checkoutExtensionData;

	useEffect(() => {
		setExtensionData('lemacaron', 'room_number', roomNumber);
	}, [setExtensionData, roomNumber]);

	const onInputChange = useCallback(
		(value) => {
			setRoomNumber(value);
			setExtensionData('lemacaron', 'room_number', value);
		},
		[setRoomNumber, setExtensionData]
	);

	return (
		<div className={'lemacaron-room-number'}>
			<ValidatedTextInput
				id="room_number"
				type="text"
				required={true}
				className={'lemacaron-room-number__input'}
				label={__('Room Number', 'lemacaron')}
				value={roomNumber}
				onChange={onInputChange}
			/>
		</div>
	);
};

const options = {
	metadata,
	component: Block,
};

registerCheckoutBlock(options);
